import StocksConfigurationProduitsController from './stocks.configuration.produits.controller';
import Template from './stocks.configuration.produits.html';
export default {
	controller: StocksConfigurationProduitsController,
	template: Template
};
